module.exports = __webpack_public_path__ + "img/3484-02.19bc3a88.png";